import apiHandler from "../core/apiHandler";

const importTypeApi = apiHandler('import-types');
export default importTypeApi;